import './styles.scss'

import { useTranslation } from 'react-i18next';
import { Text } from "@fragments";

export default function SidebarItem({ left, right, onClick, text, className = "", active = false, comingSoon = false }) {
    const { t } = useTranslation('shell');

    return (
        <div
            className={`cs-sidebar-item ${active ? 'active' : ''} ${comingSoon ? 'coming-soon' : ''} ${className}`}
            onClick={comingSoon ? undefined : onClick}
        >
            <div className="sidebar-item-left">
                {left}
            </div>
            <div className="sidebar-item-main">
                <Text.h6
                    weight={active ? 600 : 400}
                >
                    {text}
                </Text.h6>
                {comingSoon && (
                    <span className="coming-soon-badge">{t('sidebar.comingSoon')}</span>
                )}
            </div>
        </div>
    )
}